/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import FormValidations from 'cio/utils/form-validations';
import { ProductAppInfo } from 'cio/utils/product-app-info';
import { Task } from 'ember-concurrency';

interface OnboardingQuestionnaire {
  Args: {
    product: ProductAppInfo;
    question: string;
    options: {
      value: string;
      label: string;
      icon?: string;
    };
    showInput: boolean;
    formValues: string;
    formValuesOther?: string;
    formValidations: FormValidations['errors'];
    formValidationsOther?: FormValidations['errors'];
    onValueChange: (field: string, value: string | string[]) => unknown;
    submitTask: Task<unknown, [MouseEvent]>;
    field: string;
    fieldOther?: string;
    placeholder?: string;
    useCheckboxes?: boolean;
    displayClassNames?: string;
    displayItemClassNames?: string;
  };
  Element: HTMLElement;
}

export default class OnboardingQuestionnaireForm extends Component<OnboardingQuestionnaire> {
  get useCheckboxes() {
    return this.args.useCheckboxes ?? false;
  }

  get displayClassNames() {
    return this.args.displayClassNames ?? '';
  }

  get displayItemClassNames() {
    return this.args.displayItemClassNames ?? '';
  }

  get showInput() {
    return (
      (this.args.showInput && this.args.formValues === 'other') ||
      (this.args.showInput && this.useCheckboxes && this.args.formValues.includes('other'))
    );
  }
}
